import { useState, useEffect } from 'react';
import { apiGet } from './apiClient';


// ── New types ──────────────────────────────────────────────────────────────

export interface ConvictionGroupsResponse {
    groups: string[];
    total_count: number;
}

// ── New hook ───────────────────────────────────────────────────────────────

export function useConvictionGroups(): {
    data: ConvictionGroupsResponse | null;
    loading: boolean;
    error: string | null;
} {
    const [data, setData] = useState<ConvictionGroupsResponse | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;
        const controller = new AbortController();
        setLoading(true);
        setError(null);

        apiGet<ConvictionGroupsResponse>(
            '/api/screener/conviction/groups',
            controller.signal
        )
            .then(res => {
                if (!cancelled) setData(res);
            })
            .catch(err => {
                if (cancelled || err?.name === 'AbortError') return;
                setError(err.message ?? 'Failed to load conviction groups');
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        return () => {
            cancelled = true;
            controller.abort();
        };
    }, []);

    return { data, loading, error };
}